module.exports = __webpack_public_path__ + "img/dp10.78d8bff1.jpeg";